import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import productMetricReadAction from './productMetricRead.action.json'

const productMetricReadDefinition = defineReadAutoAction(productMetricReadAction, 'productMetric')

export default productMetricReadDefinition
